import React, {Component} from "react";
import {Header as MyHeader} from "../../components";
import {Button, Container, Form, Grid, Input, TextArea} from "semantic-ui-react";
import {FormattedMessage} from "react-intl";
import {ReCAPTCHA} from "react-google-recaptcha";
import {sendEmail} from "../../redux/actions";

const locale = localStorage.getItem('_LOCALE');

class Contact extends Component {

    constructor(props) {
        super(props);

        this.state = {
            name: '',
            email: '',
            message: ''
        };

        window.scrollTo(0, 0);
    }

    handleSubmit = async () => {

        try {

            const res = await sendEmail(this.state);

            if(res.success){

                alert('Mensagem enviada com sucesso!');

                window.top.location.href = '/';
            }

        } catch (e) {

            console.log(e);
        }
    }

    render() {

        const {name, email, message} = this.state;

        return (
            <React.Fragment>
                <MyHeader/>
                <Container>
                    <Grid stackable>
                        <Grid.Row>
                            <div className="column np"> </div>
                        </Grid.Row>
                        <Grid.Row>
                            <h2 className={'ui header'}><FormattedMessage id="Contato"/></h2>
                        </Grid.Row>
                        <Grid.Row>
                            <h4><FormattedMessage id="Preencha o formulário abaixo e envie sua mensagem"/></h4>
                        </Grid.Row>
                        <Grid.Row columns={'equal'}>
                            <Grid.Column>
                                <Form style={{width: 480, maxWidtht: '100%'}} onSubmit={this.handleSubmit}>
                                    <Form.Field>
                                        <label>Nome</label>
                                        <Input
                                            value={name}
                                            onChange={(e, {value}) => this.setState({name: value})}
                                            required
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>E-mail</label>
                                        <Input
                                            value={email}
                                            onChange={(e, {value}) => this.setState({email: value})}
                                            type={'email'}
                                            required
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Mensagem</label>
                                        <TextArea
                                            required
                                            rows={6}
                                            value={message}
                                            onChange={(e, {value}) => this.setState({message: value})}
                                        />
                                    </Form.Field>

                                    <ReCAPTCHA
                                        sitekey={'6Lenwe4UAAAAAEUXWBzHKWJHajNaVO254RJy-okK'}
                                        onChange={(value) => console.log('ReCAPTCHA', value)}
                                        size={'normal'}
                                        badge={'inline'}
                                    />

                                    <Button type='submit' className={'btn primary'}>
                                        <FormattedMessage id="Enviar"/>
                                    </Button>
                                </Form>
                            </Grid.Column>
                            <Grid.Column>

                                <strong><FormattedMessage id="Contatos"/></strong>
                                <br/>
                                {
                                    locale === 'pt' && <>
                                        Avenida João Pinheiro, 146 – 4 andar – Bairro: Centro - Belo Horizonte – MG – Cep: 30130-922
                                    </>
                                }
                                {
                                    locale === 'en' && <>
                                        João Pinheiro´s Avenue, 146 – 4th Floor – District: Centro – City: Belo Horizonte – State: Minas Gerais – Zip Code: 30130-922
                                    </>
                                }
                                <br/>
                                <br/>

                                E-mail: <a href={'mailto:inbh@inbh.com.br'}>inbh@inbh.com.br</a>
                                <br/>
                                Instagram: <a href={'https://instagram.com/guiainbh'} target={'_blank'}>@guiainbh</a>
                                <br/>
                                Facebook:  <a href={'https://fb.com/guiainbh'} target={'_blank'}>Guia IN BH</a>
                                <br/>
                                Twitter: <a href={'https://twitter.com/guiaINBH'} target={'_blank'}>guiaINBH</a>
                                <br/>
                                Site: <a href={'https://www.inbh.com.br'} target={'_blank'}>www.inbh.com.br</a>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row />
                    </Grid>
                </Container>
            </React.Fragment>
        );
    }
}

export default Contact;

